import React from 'react';
import { testId } from 'ui-components/services/testid-service';
import commonStyle from '../common-style.module.less';
import { CustomsTextInput } from '../customs-text-input';
import { useCustomsContext } from '../../context/context';
import type { CustomsContextValue } from '../../types';

export const CustomsExportDeclarationNumberInput = () => {
  const { exportDeclarationNumber, updateExportDeclarationNumber }: CustomsContextValue = useCustomsContext();
  return (
    <CustomsTextInput
      {...testId('customs-export-declaration-flag-input')}
      className={commonStyle['standard-input']}
      onChange={updateExportDeclarationNumber}
      type='text'
      value={exportDeclarationNumber}
    />
  );
};
